/**
 * Runtime Configuration for API Backend URL
 * 
 * This solves the deployment issue where React build-time environment variables
 * get hardcoded into the JavaScript bundle.
 * 
 * Solution: Detect the current domain at runtime and use appropriate backend URL
 */

// Function to get the correct backend URL based on current domain
export const getBackendUrl = () => {
  // Get current hostname
  const hostname = window.location.hostname;
  
  // If running on production domain, use empty string for relative URLs
  // Backend is accessible on same domain at /api
  if (hostname === 'create3dworks.com' || hostname === 'www.create3dworks.com') {
    return ''; // Relative URLs - calls /api on same domain
  }
  
  // If running on preview domain, use preview backend
  if (hostname.includes('preview.emergentagent.com')) {
    return 'https://elastic-montalcini.preview.emergentagent.com';
  }
  
  // For localhost development, use environment variable or default
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  }
  
  // Fallback: use environment variable or relative URL
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export the backend URL for use throughout the app
export const BACKEND_URL = getBackendUrl();

// Log the configuration (helps with debugging deployment issues)
console.log('🔧 Backend Configuration:', {
  hostname: window.location.hostname,
  backendUrl: BACKEND_URL,
  isRelativeUrl: BACKEND_URL === ''
});
